// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Template4_pageWrapper__NAwlL","sidebar":"Template4_sidebar__JepBZ","mainContent":"Template4_mainContent__iJCa1"};